import React from 'react';
import Card from '../Card/Card';
import { Button } from '../Button/Button';
import Typography from '../Typography/Typography';
import { useDemoRequestModal } from './DemoRequestModal';
import Spacer from '../Spacer/Spacer';
import css from './demo-request.module.scss';
import { Stack } from '../Stack/Stack';
import { useTranslation } from 'utils/translation';

const DemoRequestCallToAction = () => {
  const demoRequest = useDemoRequestModal();
  const { t } = useTranslation();

  return (
    <div className={css.root}>
      <Card className={css.card} rounded>
        <Card.Content>
          <Stack direction="column" justify="center" align="center">
            <Typography className={css.text} align="center">
              <strong>{t('demo_request_cta_title')}</strong>
            </Typography>
            <Spacer size={2} />
            <Button className={css.button} size="small" onClick={demoRequest}>
              {t('demo_request_cta_button')}
            </Button>
          </Stack>
        </Card.Content>
      </Card>
    </div>
  );
};

export default DemoRequestCallToAction;
